/**
 * Created by neo on 01.02.21.
 */
import { makeAutoObservable } from 'mobx';
import { Media, createMedia } from '../Media/Media';

export type MediaNarratorAudioTrackJson = {
  language: string;
  media: Partial<Media>;
};

export type MediaNarratorAudioTrack = {
  language: string;
  media: Media;
};

export function createMediaNarratorAudioTrack(json?: Partial<MediaNarratorAudioTrackJson>): MediaNarratorAudioTrack {
  return makeAutoObservable({
    language: json?.language ?? 'de',
    media: createMedia(json?.media),
  });
}
